import React from 'react';
import { FaStar, FaHeart } from 'react-icons/fa';
import { Helmet } from "react-helmet";

function About() {
  const teamMembers = [
    {
      id: 1,
      name: 'Kertész Anna',
      position: 'Főszerkesztő, Kertészmérnök',
      bio: 'Több mint 15 éves gyakorlati tapasztalat organikus kertészetben. Szakértője a talajéletnek és a komposztálásnak.',
      gender: 'female'
    },
    {
      id: 2,
      name: 'Szabó Mária',
      position: 'Növénypatológus',
      bio: 'Doktori fokozat növényvédelemből. Szenvedélyesen kutatja a természetes kártevőirtási módszereket.',
      gender: 'female'
    },
    {
      id: 3,
      name: 'Molnár Péter',
      position: 'Tájépítész',
      bio: 'Modern városi kertek tervezésére specializálódott. Szereti az erkélykerteket és a függőleges zöld megoldásokat.',
      gender: 'male'
    },
    {
      id: 4,
      name: 'Kovács Éva',
      position: 'Vízmenedzsment szakértő',
      bio: 'A vízgazdálkodás és hatékony öntözési rendszerek szakértője. Oktatóként tanítja a vízmegtakarítási praktikákat.',
      gender: 'female'
    },
    {
      id: 5,
      name: 'Nagy István',
      position: 'Gyümölcstermesztő',
      bio: 'Bio gyümölcsöskertje van, ahol régi gyümölcsfajtákat ment. Nyitott birtokain szívesen vezet gyakorlati foglalkozásokat.',
      gender: 'male'
    }
  ];

  return (
    <>
      <Helmet>
        <title>Bromeli - Kertészeti Tanácsadó Blog</title>
        <meta name="description" content="Bromeli kertészeti blog - szakértői tanácsok, növényápolási tippek, fenntartható kertészeti megoldások és szezonális kerti kalauz." />
      </Helmet>

      <div className="container">
      <section className="about-section" style={{ marginTop: '40px' }}>
        <h2>A Bromeli Kertészeti Blog története</h2>
        <p>
          A Bromeli Kertészeti Blog 2017-ben indult útjára azzal a céllal, hogy megbízható, gyakorlati alapú 
          kertészeti tanácsokkal lássa el az otthoni kertbarátokat. Névadónk, a bromélia növénycsalád, 
          tökéletesen szimbolizálja küldetésünket: a sokszínűséget, az alkalmazkodóképességet és a természet 
          szépségét.
        </p>
        <p>
          Azóta csapatunk folyamatosan bővült, hogy minél átfogóbb képet nyújthasson a kertészkedés világából. 
          Ma már több szakértő kolléga dolgozik azon, hogy friss és hasznos tartalmakat készítsen Önnek. 
          Büszkék vagyunk arra, hogy olvasóink ezrei találtak már hasznos megoldásokat írásainkban.
        </p>
        <p>
          Küldetésünk, hogy fenntartható, az emberek és a környezet számára egyaránt előnyös kertészeti 
          gyakorlatokat népszerűsítsünk. Hiszünk abban, hogy mindenki képes szép és termékeny kertet 
          létrehozni, ha megfelelő tudással és inspirációval rendelkezik.
        </p>
      </section>

      <section className="container">
        <div className="section-header">
          <h2>Csapatunk</h2>
          <p>Ismerje meg a Bromeli szakértői csapatát, akik nap mint nap az Ön kertjének szépségéért dolgoznak.</p>
        </div>
        <div className="about-team">
          {teamMembers.map(member => (
            <div className="team-member" key={member.id}>
              <img src={`/images/team_${member.id}.jpg`} width="400" height="400" alt={`Csapattag ${member.name}`} />
              <h3>{member.name}</h3>
              <p className="position">{member.position}</p>
              <p className="bio">{member.bio}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="container" style={{ marginTop: '50px', marginBottom: '50px' }}>
        <div className="features">
          <div className="feature-card">
            <div className="feature-icon"><FaStar /></div>
            <h3>Minőségi tartalom</h3>
            <p>Minden bejegyzésünk szakértői áttekintésen és gyakorlati teszteken esik át.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon"><FaHeart /></div>
            <h3>Közösségi hozzáállás</h3>
            <p>Rendszeresen tartunk nyílt napokat és webináriumokat olvasóinknak.</p>
          </div>
        </div>
      </section>
    </div>
  
    </>);
}

export default About;